import React, {forwardRef}  from "react";
import {constants} from "@/constants.js";
import {urlChatID} from "@/utils/url.js";

import {useQueryClient, useQuery} from 'react-query';
import Icon from "@/components/ui/Icon.jsx";
import {EventBus} from "@/store/event-bus.ts";
import {queryKey} from "@/store/queryKeys.ts";
import DocStatusBadge from "@/components/DocStatusBadge.jsx";
import {useTranslation} from "react-i18next";


const ListFiles = () => {
    const queryClient = useQueryClient();
    const {t} = useTranslation();

    let {isLoading, isError, data} = useQuery(queryKey.chatbotSourcesFiles(), async function() {
        let res = await fetch(`${constants.url.API_PREFIX}chatbot/${urlChatID()}/files`)
        return res.json()
    });
    const invalidateCache = () => {
        queryClient.invalidateQueries(queryKey.chatbotSourcesFiles())
        queryClient.invalidateQueries(queryKey.chatbotSummary)
    }

    const [uploadHandler, setUploadHandler] = React.useState(false)

    if (!uploadHandler) {
        setUploadHandler(true)
        let bus = EventBus.getInstance().registerSingle('chatbot.sources.files.upload_finished', () =>{
            invalidateCache()
        })
    }
    const apiDocumentDelete = (id) => {
        return fetch(`${constants.url.API_PREFIX}chatbot/${urlChatID()}/document/${id}/delete`)
            .then(invalidateCache)
    }

    if (isLoading) return <p>Loading...</p>;
    if (isError || !data) return <p>Error: Can't load files</p>;

    let charactersTotal = 0;
    return (
        <div className="mt-4">
            <div className="py-1 font-bold flex justify-between">
                <div className="w-3/4 flex items-center">
                    {t("knowledge_base.files")} {data.files.length ? `(${data.files.length})` : ``}
                </div>
                <div className="flex justify-center w-20">
                  {t("knowledge_base.characters")}
                </div>
                <div className="flex justify-center w-20">
                  {t("knowledge_base.actions")}
                </div>
            </div>
            {data.files.map((file, i) => {
                charactersTotal += file.characters !== -1 ? file.characters : 0;
                return (
                    <div key={i} className="py-1 hover:bg-slate-200 flex justify-between">
                        <div className="w-3/4 flex">
                            <div className="w-20">
                                <DocStatusBadge status={file.status} />
                            </div>
                            {file.file}
                        </div>
                        <div className="flex justify-center w-20">
                            {file.characters !== -1 ? file.characters : ''}
                        </div>
                        <div className="flex justify-center items-center w-20">
                            <div className="cursor-pointer"
                                 title={"Delete file"}
                                 onClick={(e) => apiDocumentDelete(file.id)}
                            >
                                <Icon icon="heroicons:archive-box-x-mark" className="w-6 h-6 text-gray-400 hover:text-red-600"/>
                            </div>
                        </div>
                    </div>
                );
            })}
            {!!data.files.length &&
                <div className="py-1 font-bold flex justify-between">
                    <div className="w-3/4 flex items-center">
                    </div>
                    <div className="flex justify-center w-20">
                        {charactersTotal ? charactersTotal : ''}
                    </div>
                    <div className="flex justify-center w-20">
                    </div>
                </div>
            }
        </div>
    )
}

export default ListFiles